import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./comps/pages/Home";
import About from "./comps/pages/About";
import Header from "./comps/commons/Header";
import Footer from "./comps/commons/Footer";
import Services from "./comps/pages/Services";
import Gallery from "./comps/pages/Gallery";
import Contact from "./comps/pages/Contact";
import Offerings from "./comps/pages/Offerings";
import Domain from "./comps/pages/Domain";
import InProgress from "./comps/commons/InProgress";
const Layout = () => {
    return (
        <BrowserRouter>
            <div className="wrapper">
                <div className="wrapperin">
                    <Header />
                    <div className="pages">
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="about" element={<About />} />
                            <Route path="services" element={<Services />} />
                            <Route path="offerings" element={<Offerings />} />
                            <Route path="domain" element={<Domain />} />
                            <Route path="gallery" element={<Gallery />} />
                            <Route path="contact" element={<Contact />} />
                            <Route path="inprogress" element={<InProgress />} />
                        </Routes>
                    </div>
                    <Footer />
                </div>
            </div>
        </BrowserRouter>
    )
}
export default Layout;